import {
    withRequiredAuthInfo,
    WithLoggedInAuthInfoProps,
} from "@propelauth/react";
import {Link, useNavigate} from "react-router-dom";
import ListOfProjectCards from "../projects/ProjectCard_v2";
import "../../styles.css";
import {Button} from "../ui/button";

function DeveloperHome(props: WithLoggedInAuthInfoProps) {
    const navigate = useNavigate()
    return (
        <div>
            <div className="columns-2 justify-between flex">
                     <h3 className="mb-2 text-lg font-semibold text-gray-800">
                Your projects
            </h3>
                <Button variant={'outline'}
                        onClick={(e) => navigate("project/create")} 
                        className="mb-2">
                    Create New project
                </Button>
            </div>


            <ListOfProjectCards />

        </div>
    );
}

// By default, if the user is not logged in they are redirected to the login page
export default withRequiredAuthInfo(DeveloperHome);
